module.exports = __webpack_public_path__ + "img/banner.d82a74b6.svg";